var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PthPadstackData = require('../../../padstack/pthPadstackData.js');
var PadData = require('../../padData.js');
var HoleData = require('../../holeData.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var RectangleData = require('../../../svg/rectangleData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var AbstractIPCData = require("../../../abstract/abstractIPCData.js");
var IPCRules = require('../ipcRules.js');
var ThermalConnectionTypes = require("../../../thermalConnectionTypes.js");
var IPCPthFootprintCalculator = require('./pthCalculator.js');

/**
 * @constructor
 * @param {object} root
 * @param {lib_geometry.Coord} position
 * @param {number} angle Angle in degrees
 * @param {boolean} init Initialize members
 */
var IpcPthPadGeneratorData = function(position, angle, init) {
    AbstractIPCData.apply(this, arguments);

    /////////////////////////////
    // IPC PTH parameters list //
    /////////////////////////////
    this.terminalWidth = this.value("terminalWidth", true);
    this.terminalLength = this.value("terminalLength", true);

    this.padToHoleRatio = this.value("padToHoleRatio", true);

    this.update3dModelNonTriggerList.push("padToHoleRatio");

    //////////////////////////////////////////////////
    // Used for padstack motif geometry calculation //
    //////////////////////////////////////////////////

    //these values are populated using IPC calculated values
    this.padGeometry = {width: 0, length: 0};
    this.holeGeometry = {diameter: 0};
    this.roundOffFactor = 100; //upto two decimal places

    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalWidth);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalLength);
    this.nonTransformedSegmentedGeometry.addTrigger(this.padToHoleRatio);

    if(init) {
        this.padShape(PthComponentAttribute.padShapes["Round"]);
    }
};

lib_core.inherit(IpcPthPadGeneratorData, AbstractIPCData);
lib_core.JsonParser.registerClass(IpcPthPadGeneratorData, "IpcPthPadGeneratorData");

module.exports = IpcPthPadGeneratorData;

IpcPthPadGeneratorData.prototype.setupMinMaxPtrMap = function() {
    AbstractIPCData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["terminalWidth"] = [this.terminalWidth];
    this.validationMap["terminalLength"] = [this.terminalLength];
};

IpcPthPadGeneratorData.prototype.getTerminalDiameter = function() {
    return this.terminalWidth();
};

/**
 * IPC calculation for pad and drill sizes using the following formulas
 *
 * Drill Size = Maximum Lead diameter + Hole Over Lead
 * Pad Diameter = Minimum Annular Ring X 2 + Minimum Fabrication Allowance + Drill Size
 */
IpcPthPadGeneratorData.prototype.calculateDrillSize = function(terminalDia) {
    var holeOverLead = IPCRules.pthPadGoal.holeDiameterFactor[this.densityLevel()];
    this.holeGeometry.diameter = IPCPthFootprintCalculator.hole(terminalDia, holeOverLead);
};

IpcPthPadGeneratorData.prototype.calculatePadSize = function(holeDia) {
    console.assert(holeDia > 0, "Hole diameter must be greater than zero for pth pad.");

    var minFabAllowance = IPCRules.pthFabrication.allowance[this.densityLevel()];
    this.padGeometry.width = this.padGeometry.length = this.precisionRound(IPCPthFootprintCalculator.pad(holeDia, IPCRules.pthFabrication.minAnnularRingWidth, minFabAllowance, this.padToHoleRatio()), this.roundOffFactor);
};

IpcPthPadGeneratorData.prototype.getPadShapeData = function() {
    var shape = null;

    if(this.padShape() === PthComponentAttribute.padShapes["Square"] || this.padShape() === PthComponentAttribute.padShapes["RoundedSquare"]) {
        shape = new RectangleData(new lib_geometry.Coord(0, 0), 0, 0, 0, true, 0);
    } else if(this.padShape() === PthComponentAttribute.padShapes["Round"]) {
        shape = new EllipseData(new lib_geometry.Coord(0, 0), 0, 0, 0, true, 0);
    }

    return shape;
};

/**
 * Update hole geometry by IPC calculated values
 */
IpcPthPadGeneratorData.prototype.getMotifHoleData = function(motifHoleDia) {
    //do IPC calculation
    this.calculateDrillSize(motifHoleDia);

    var drillDiameter = this.holeGeometry.diameter;
    var drillShape = new EllipseData(new lib_geometry.Coord(0, 0), 0, drillDiameter, drillDiameter, true, 0);
    var hole = new HoleData(new lib_geometry.Coord(0,0), 0, drillShape);

    return hole;
};

/**
 * Update pad shape by IPC calculated values
 */
IpcPthPadGeneratorData.prototype.getMotifShapeData = function(motifHoleDia) {
    var self = this;

    //do IPC calculation
    this.calculatePadSize(motifHoleDia);

    var shape = this.getPadShapeData();

    //update pad shape size with IPC calulated values
    shape.width(this.padGeometry.width);
    shape.height(this.padGeometry.length);

    //update corner radius for rounded square shape
    if(this.padShape() === PthComponentAttribute.padShapes["RoundedSquare"]) {
        var cornerRadius = Math.min(shape.height(), shape.width()) * (self.roundedPadCornerSize() / 100);

        //check radius size limit
        if(cornerRadius > IPCRules.roundedPadCornerRadiusSizeLimit) {
            cornerRadius = IPCRules.roundedPadCornerRadiusSizeLimit;
        }

        shape.rx(cornerRadius);
        shape.ry(cornerRadius);
    }

    return shape;
};

/**
 * Create an instance of motif object (pad data with pth pad stack)
 * @return {PadData} Pad data.
 */
IpcPthPadGeneratorData.prototype.getMotif = function() {
    // get hole data for motif
    var hole = this.getMotifHoleData(this.getTerminalDiameter());

    // get pad's shape data for motif
    var shape = this.getMotifShapeData(hole.shape().width());

    var padstack = new PthPadstackData(shape, shape.clone(), hole, true, false, 101.6, ThermalConnectionTypes.RELIEF);
    var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__pthPadReplicatorMotif__", padstack, true);

    return motif;
};